import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useParams } from "react-router-dom";
import ModalVisible from "../CohortGroupSession/Modal/modal";
import BasicModal from "../../../../common/summaryMentorModal/Modal";
import { DoubleArrow, FiberManualRecordRounded } from "@material-ui/icons";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import swal from "sweetalert";
import cohortMeetingWhite from "../../../../../assets/svg/cohortMeeting.svg";
// import DownloadButton from "../../../../../assets/svg/downloadButtonBlack.svg";
// import startupMiniCircle from "../../../../../assets/svg/startupMiniCircle.svg";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./index.scss";
import api from "../../../../common/dependencies/utils/Api";
import {
  COHORT_NAME_LIST,
  GROUP_SESSION_NAME_LIST,
  MATCH_MENTOR_LIST,
  PUBLIC_LIST_GROUP_SESSIONS,
  COHORT_PARTICULAR,
  COHORT_ADD_RESOURCES,
  COHORT_VIEW_ALL_RESOURCES,
  SCHEDULE_RESOURCES_COUNTER,
} from "../../../../common/constants/ApplicationUrl";
import polygon1 from "../../../../../assets/svg/Polygon1.svg";
import {
  getStepperTooltipData,
  getCohortPublicData,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortGroupSessionHours,
  cohortGroupSessionHoursFilter,
} from "../dependencies/action";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import { ReactComponent as UploadResource } from "../../../../../assets/svg/uploadFile.svg";
import { ReactComponent as ResourceFile } from "../../../../../assets/svg/resourceFile.svg";
import VideoPlaceholder from "../../../../../assets/images/videoPlaceholerd.jpeg";
import BlackPDF from "../../../../../assets/svg/pdfBlack.svg";
import StarIcon from "../../../../../assets/svg/star.svg";
import ModeratorCopy from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import PlayButton from "../../../../../assets/svg/playButton.svg";
import DownloadBtn from "../../../../../assets/svg/downloadButtonBlack.svg";
import WhitePDF from "../../../../../assets/svg/pdfWhite.svg";
import DocumentImage from "../../../../../assets/svg/resourceFile.svg";
// import UploadResource from "../../../../../assets/images/uploadFileImage.jpeg";
import Pagination from "react-js-pagination";
import { Country, State, City } from "country-state-city";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import {
  getNamesList,
  getCohortApplicationCounter,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import ModalFilter2 from "../../../../common/modalFilter2";
import infoButton from "../../../../../assets/svg/informationIcon.svg";
import SessionsModal from "../../../../common/sessionsModal";
import SessionGroupFeedbackModal from "../../../../common/groupSessionNotesModal";
import { COHORT_SESSION_NOTES_VIEW_FEEDBACK } from "../../../../common/constants/ApplicationUrl";
import ModalDocUpload from "../../../../common/modalDocUpload";
import uploadDocPopUp from "../../../../common/chatBox/uploadDocPopUp";
import { forEach } from "lodash";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "30px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontFamily: "Montserrat",
    padding: "10px 10px",
    borderRadius: "8px",
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDotLower: {
    color: "#816aaf",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: "14px",
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lowerButtonsContainer: {
    padding: "0 35%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  sendRequestButton: {
    height: "88.0781px !important",
    maxWidth: "none",
  },
  tableContainer: {
    // padding: "10px 10px 20px 10px",
    margin: "0 7% 50px 7%",
  },
  upperDisplayButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  filterContainer: {
    padding: "40px 7% 0 7%",
    display: "flex",
    alignItems: "center",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
}));
const ScheduleResources = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
    //   CryptoJS.enc.Hex
    // );

    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    // let aesText = iv + "::" + salt + "::" + ciphertext;

    return btoa(text);
  };
  const {
    getNamesList,
    getNamesListData,
    getCohortApplicationCounter,
    getTableCounterData,
    getTableData,
    listGroupSession,
    listGroupSessionPaginate,
    listGroupSessionData,
    detailsGroupSession,
    detailsGroupSessionData,
    cohortSessionNotesGiveFeedBack,
    cohortSessionNotesViewFeedBack,
    sessionFeedBackData,
    sessionNotesFeedBackData,
    cohortGroupSessionHoursData,
    parentData,
    setParentData,
    commonCohortId,
    setCommonCohortId,
  } = props;
  const [activeText, setActiveText] = useState(false);
  const selectRef = useRef();

  const [menuIsOpen, setMenuIsOpen] = useState();
  const [menuWidth, setMenuWidth] = useState();
  const [isCalculatingWidth, setIsCalculatingWidth] = useState(false);
  const [activeText0, setActiveText0] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activeText5, setActiveText5] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [activePageResources, setActivePageResources] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");
  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [sessionHoursBtnPressed, setSessionHoursBtnPressed] = useState(false);
  const [mentorFeedbackModalOpen, setMentorFeedbackModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const classes = useStyles();
  const [sessionModalData, setSessionModalData] = useState(null);
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const [sessionModalChild, setSessionModalChild] = useState(false);
  const html = document.getElementsByTagName("html")[0];
  const [cohortGroupSessionId, setCohortGroupSessionId] = useState("");
  const [cohortAdminId, setCohortAdminId] = useState("");
  const [cohortGroupSessionList, setCohortGroupSessionList] = useState([]);
  const [searchCohortId, setSearchCohortId] = useState("");
  const [feedbackMode, setFeedbackMode] = useState(false);
  const [clipBoardImgShow, setClipBoardImgShow] = useState("");
  const [showVideo, setShowVideo] = useState();
  const [videoUrl, setVideoUrl] = useState();
  const [videoArr, setVideoArr] = useState([]);
  const [newCohortid, setNewCohortid] = useState();
  const [clickModaldata, setClickmodaldata] = useState([]);
  const [selectedNavigation, setSelectedNavigation] = useState("");
  const [recordingTotal, setRecordingTotal] = useState([]);
  const [recordingTotal2, setRecordingTotal2] = useState([]);
  const [recordingTotal3, setRecordingTotal3] = useState([]);
  const [activePageVideo, setActivePageVideo] = useState(1);
  const [cohortAdminBoolean, setCohortAdminBoolean] = useState(false);
  const [cohortCounter,setCohortCounter] = useState(false);
  const [recordingPaginate, setRecordingPaginate] = useState({
    pageSize: 6,
    currentPage: 1,
    numPages: "",
    itemCount: "",
    totalElements: "",
  });
  const [resourcesPaginate, setResourcesPaginate] = useState({
    pageSize: 5,
    currentPage: 1,
    numPages: "",
    itemCount: "",
    totalElements: "",
  });
  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };
  const paramsPage = useParams();
  useEffect(() => {
    let params = {
      userId: loggedIn?.id,
      cohortId: paramsPage?.cohortId,
      fromInvitationList: false,
      sessionStatus: selectedStatus,
      pageFilter: {
        pageSize: 9,
        currentPage: 0,
      },
    };
    listGroupSession(params);
    setSelectedNavigation(2);
  }, [paramsPage]);

  const handleLoginClick = () => {
    localStorage.setItem("path", "path");
    history.push({
      pathname: "/cohort-form",
      state: {
        fromPage: "cohort-application",
      },
    });
  };
  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalVisibility2, setModalVisibility2] = useState(false);
  // const [toggleMentor, setToggleMentor] = useState(false);

  const [fromModule, setFromModule] = useState("");
  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [calendarStatus, setCalendarStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [taggingList, setTaggingList] = useState([]);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [isShown, setIsShown] = useState(false);
  const [linkToggleCopy, setLinkToogleCopy] = useState(false);
  const [linkToggleCopyModerator, setLinkToogleCopyModerator] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [sessionMomChildData, setSessionMomChildData] = useState("");
  const [canDelete, setCanDelete] = useState(false);
  const [currentList, setCurrentList] = useState("");
  const [sessionTitle, setSessionTitle] = useState("");
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [uploadDocumentParent, setUploadDocumentParent] = useState(false);
  const [currentListPaginate, setCurrentListPaginate] = useState("");
  const [linkToggleText, setLinkToogleText] = useState(
    "Click to Copy MAAARG session Link"
  );
  const [resourcesList, setResourcesList] = useState([]);
  const [linkToggleTextModerator, setLinkToogleTextModerator] = useState(
    "Click to Copy MAAARG session Link as a Moderator"
  );
  const selectInputRef = useRef();

  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getTableDataPaginate,
    getStepperTooltipData,
    getStepperData,
    invitedSessionMembersList,
    statusGroupSession,
    invitedSessionList,
    invitedSessionListPaginate,
    groupSessionCounter,
    listGroupSessionCounter,
    cohortGroupSessionHours,
    getCohortPublicData,
    cohortCounterData,
    cohortGroupSessionHoursFilter,
    cohortGroupSessionHoursFilteredData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  useEffect(() => {
    // axios({
    //   // url: GET_NAMES_DATA,
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Mentor",
    //   },
    // })

    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Mentor",
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Startup",
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  }, []);

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  // if (loginrole === "Mentor" || loginrole === "Admin") {
  //   localStorage.setItem("CohortGroupSession", "CohortGroupSession");
  // } else {
  //   localStorage.removeItem("CohortGroupSession");
  //   history.push("/startup-dashboard");
  // }

  useEffect(() => {
    html.style.overflow = "auto";

    // localStorage.setItem("CohortGroupSession", "CohortGroupSession");
    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
    }, 1000);
    localStorage.removeItem("path");
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     mentorId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
    //     status: "VERIFIED",
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        mentorId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
        status: "VERIFIED",
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            if (item.name !== "" && item.name !== null) {
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
          });
      })
      .catch((err) => {});

    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     mentorId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        mentorId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Id",
                value: "select",
              };
              setcohortnameId((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: `C${item.id.slice(-6)}`,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameId.length)
              setcohortnameId((oldArray) => [...oldArray, arr]);
          });
      })
      .catch((err) => {});
  }, []);
  const fetchUploadedResouces = () => {
    api
      .POST(COHORT_VIEW_ALL_RESOURCES, {
        cohortId: paramsPage?.cohortId,
      })
      .then((res) => {
        let incomingData = res?.data?.data;
        if (
          incomingData !== undefined &&
          incomingData !== null &&
          incomingData !== "" &&
          incomingData?.length > 0
        ) {
          incomingData.forEach((item, index) => {
            // if(!resourcesList.includes({url:item?.path,name: item?.title}))
            let test = true;
            if (resourcesList?.length > 0) {
              resourcesList.forEach((item2, index) => {
                if (item2?.url == item?.path)
                test = false
              });
            }
             if(test)
              setResourcesList((prevState) => [
                ...prevState,
                {
                  url: item?.path,
                  name:
                    item?.title == null ||
                    item?.title == "" ||
                    item?.title == null
                      ? "Uploaded Resource"
                      : item?.title,
                },
              ]);
          });
          // Testpaginate(resourcesList)
          // setResourcesPaginate({
          //   pageSize: 5,
          //   currentPage: 1,
          //   numPages: Math.ceil(resourcesList?.length / 5),
          //   itemCount: "",
          //   totalElements: resourcesList?.length,
          // })
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    fetchUploadedResouces();
    setActiveText0(true);
    getTableDataStatus("");
    setSelectedStatus("");
    counterFn();
  }, []);
  useEffect(() => {
    let params = {
      userId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
      fromInvitationList: false,
    };
    listGroupSessionCounter(params);
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    if (linkToggleCopy) {
      setTimeout(() => {
        setLinkToogleCopy(false);
        setLinkToogleText("Click to join MAAARG session Link");
      }, 5000);
    }
  }, [linkToggleCopy]);
  useEffect(() => {
    if (linkToggleCopyModerator) {
      setTimeout(() => {
        setLinkToogleCopyModerator(false);
        setLinkToogleTextModerator(
          "Click to join MAAARG session Link as a Moderator"
        );
      }, 5000);
    }
  }, [linkToggleCopyModerator]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     let params = {
  //       userId: loggedIn?.id,
  //       fromInvitationList: false,
  //       pageFilter: {
  //         pageSize: 9,
  //         currentPage: 0,
  //       },
  //     };
  //     listGroupSession(params);
  //     setRefreshPage(false);
  //     let params2 = {
  //       userId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
  //       fromInvitationList: false,
  //     };
  //     listGroupSessionCounter(params2);
  //     // getGroupSessionFn();
  //     setActivePage(1);
  //   }, 1000);
  // }, [refreshPage]);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);

  useEffect(() => {
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);

  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      height: "35px",
      color: "#333",
      width: "max-content",
      minWidth: "15rem",
      maxWidth: loginrole === "Admin" ? "" : "25rem",
      // marginRight:"10px"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        textAlign: "left",
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
        width: "auto",
      };
    },
    menu: ({ width, ...css }) => ({
      ...css,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
    // menu: (base) => ({
    //   ...base,
    //   width: "max-content",
    //   minWidth: "100%",
    //   fontSize: "14px",
    // }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    newTableFn(pageNumber - 1);
  };

  useEffect(() => {
    if (detailsGroupSession !== undefined) {
      setSessionModalData(detailsGroupSessionData);
    }
  }, [detailsGroupSessionData]);

  useEffect(() => {
    setTableList(startUpApplication);
    let data = startUpApplication?.requestJson;
    setMentorShipReqData(data);
  }, [startUpApplication]);

  const getTableDataStatus = (status) => {
    let params;
    if (searchCohortId === "") {
      params = {
        userId: loggedIn?.id,
        fromInvitationList: false,
        sessionStatus: status,
        pageFilter: {
          pageSize: 9,
          currentPage: 0,
        },
      };
      listGroupSession(params);
    } else {
      params = {
        userId: loggedIn?.id,
        fromInvitationList: false,
        sessionStatus: status,
        cohortId: searchCohortId,
        pageFilter: {
          pageSize: 9,
          currentPage: 0,
        },
      };
      listGroupSession(params);
    }
    // let params = {
    //   userId: loggedIn?.id,
    //   fromInvitationList: false,
    //   sessionStatus: status,
    //   pageFilter: {
    //     pageSize: 9,
    //     currentPage: 0,
    //   },
    // };
    // listGroupSession(params);
  };

  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(
      `/mentor-profile/${encryptAES2(item, PROFILE_KEY)}`,
      "_blank"
    );
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };

  useEffect(() => {
    if (sessionNotesFeedBackData !== undefined) {
      setSessionMomChildData(sessionNotesFeedBackData);
    }
  }, [sessionNotesFeedBackData]);

  const renderTable = () => {
    setTimeout(() => {
      let params = {
        userId: loggedIn?.id,
        fromInvitationList: false,
        sessionStatus: selectedStatus,
        pageFilter: {
          pageSize: 9,
          currentPage: 0,
        },
      };
      listGroupSession(params);
      let params2 = {
        userId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
        fromInvitationList: false,
      };
      listGroupSessionCounter(params2);
    }, 2000);
  };

  const roundUP = (num, decimalPlaces = 0) => {
    var p = Math.pow(10, decimalPlaces);
    var n = num * p * (1 + Number.EPSILON);
    return Math.round(n) / p;
  };
  const colorTester = (status) => {
    if (status == "SCHEDULED") return "#b499c7";
    else if (status == "CLOSED") return "#7784d8";
    else if (status == "COMPLETED") return "#92a9b0";
    else if (status == "CANCELLED") return "#d07979";
  };
  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dateFormat = (inputDate, time) => {
    var arr = inputDate.split("/");
    let monthName = monthNames[parseInt(arr[1], 10) - 1];
    return `${arr[0]} ${monthName} ${arr[2].slice(arr[2].length - 2)} `;
  };
  const getSessionDetails = (id) => {
    let params = {
      cohortGroupSessionId: id,
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    detailsGroupSession(params);
  };
  useEffect(() => {
    if (
      parentData !== undefined &&
      parentData !== null &&
      parentData !== "" &&
      parentData
    ) {
      newTableFn(0);
    }
  }, [parentData]);
  useEffect(() => {
    if (
      refreshPage !== undefined &&
      refreshPage !== null &&
      refreshPage !== "" &&
      refreshPage
    ) {
      newTableFn(0);
      sessionNotesFuntion();
      fetchUploadedResouces();
      setTimeout(() => {
        setRefreshPage(false);
      }, 2000);
    }
  }, [refreshPage]);
  const handleView = (videourl, videoArray, cohortAdminId, title) => {
    setVideoUrl(videourl);
    setShowVideo(true);
    setSessionTitle(title);
    if (
      videoArray !== undefined &&
      videoArray !== null &&
      videoArray !== "" &&
      videoArray?.length > 0
    )
      setVideoArr(videoArray);
    if (cohortAdminId == loggedIn?.id || loggedIn?.role == "Admin") {
      setCanDelete(true);
    } else {
      setCanDelete(false);
    }
  };
  const newTableFn = (pageNumber) => {
    var localTime = new Date(); // store localTime
    let localFullTime = localTime.toISOString();
    var proposedDate = localTime + "T00:00:00.000Z";
    var momentDate = moment(proposedDate);
    var startMonth = moment(localTime).subtract(366, "day").toDate();
    var endMonth = moment(localTime).add(30, "day").toDate();
    var endMonth2 = endMonth.toISOString();
    var hour = momentDate.hours();
    var minutes = momentDate.minutes();
    var seconds = momentDate.seconds();
    let paramsNew = {
      sessionStatus:
        selectedStatus !== undefined &&
        selectedStatus !== "" &&
        selectedStatus !== null
          ? selectedStatus
          : "",
      cohortId: parentData?.cohortId,
      sessionStartDate: startMonth,
      sessionEndDate: endMonth2,
      pageFilter: { pageSize: 6, currentPage: pageNumber },
    };
    api
      .POST(`${PUBLIC_LIST_GROUP_SESSIONS}`, paramsNew)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data?.length > 0) {
            // console.log("INCOMING DATA", response.data.data);
            setCurrentList(response.data.data);
            setCurrentListPaginate(response.data.paginate);
          } else if (response?.data?.data?.length == 0) {
            setCurrentList("");
            setCurrentListPaginate("");
          }
        }
      })
      .catch((e) => {});
  
  };
  const counterFn = ()=>{
    var localTime = new Date(); // store localTime
    let localFullTime = localTime.toISOString();
    var proposedDate = localTime + "T00:00:00.000Z";
    var momentDate = moment(proposedDate);
    var startMonth = moment(localTime).subtract(366, "day").toDate();
    var endMonth = moment(localTime).add(30, "day").toDate();
    var endMonth2 = endMonth.toISOString();
    let paramsCounter = {
      userId:loggedIn?.id,
      cohortId: parentData?.cohortId,
      sessionStartDate: startMonth,
      sessionEndDate: endMonth2,
      fromInvitationList:false,
    };
    api
    .POST(`${SCHEDULE_RESOURCES_COUNTER}`, paramsCounter)
    .then((response) => {
      const { data, status } = response || {};
      if (status === 200) {
        setCohortCounter(data?.data)
      }
    })
    .catch((e) => {});
  }
  const newTableFnStatus = (status) => {
    var localTime = new Date(); // store localTime
    let localFullTime = localTime.toISOString();
    var proposedDate = localTime + "T00:00:00.000Z";
    var momentDate = moment(proposedDate);
    var startMonth = moment(localTime).subtract(30, "day").toDate();
    var endMonth = moment(localTime).add(30, "day").toDate();
    var endMonth2 = endMonth.toISOString();
    var hour = momentDate.hours();
    var minutes = momentDate.minutes();
    var seconds = momentDate.seconds();
    // let paramsTest = {
    //   cohortId: parentData?.cohortId,
    //   sessionStartDate: startMonth,
    //   sessionEndDate: endMonth2,
    // };
    let paramsNew = {
      sessionStatus: status,
      cohortId: parentData?.cohortId,
      sessionStartDate: startMonth,
      sessionEndDate: endMonth2,
      pageFilter: { pageSize: 6, currentPage: 0 },
    };
    api
      .POST(`${PUBLIC_LIST_GROUP_SESSIONS}`, paramsNew)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data?.length > 0) {
            // console.log("INCOMING DATA", response.data.data);
            setCurrentList(response.data.data);
            setCurrentListPaginate(response.data.paginate);
          } else {
            setCurrentList("");
            setCurrentListPaginate("");
          }
        }
      })
      .catch((e) => {});
  };
  

  // useEffect(() => {
  //   if (
  //     currentList !== "" &&
  //     currentList !== undefined &&
  //     currentList !== null &&
  //     currentList?.length > 0
  //   ) {
  //     let testArr = [];
  //     currentList.forEach((item, index) => {
  //       if (
  //         item?.recordings !== "" &&
  //         item?.recordings !== undefined &&
  //         item?.recordings !== null &&
  //         item?.recordings?.length > 0
  //       ) {
  //         item?.recordings.forEach((item2, index2) => {
  //           testArr.push({
  //             videoUrl: item2,
  //             videoSessionTitle: `${item?.sessionTitle}`,
  //             videoSessionNo: `Recording ${index2 + 1}`,
  //           });
  //         });
  //       }
  //     });
  //     if (testArr?.length > 0) {
  //       setRecordingTotal(testArr);

  //       Testpaginate(testArr, 6, 1);
  //       setRecordingPaginate({
  //         pageSize: 6,
  //         currentPage: 1,
  //         numPages: Math.ceil((testArr?.length + 1) / 6),
  //         itemCount: "",
  //         totalElements: testArr?.length,
  //       });
  //     } else {
  //       setRecordingTotal([]);
  //       setRecordingTotal2([]);
  //       setRecordingPaginate("");
  //     }
  //     // console.log("testArr", testArr);
  //   }
  // }, [currentList]);
 
  useEffect(() => {
    if (
      currentList !== "" &&
      currentList !== undefined &&
      currentList !== null &&
      currentList?.length > 0
    ) {
      let testArr = [];
    
      currentList.forEach((item, index) => {
        if (
          item?.recordings !== "" &&
          item?.recordings !== undefined &&
          item?.recordings !== null &&
          item?.recordings?.length > 0
        ) {
          testArr.push(item);
        }
      });
      if (testArr?.length > 0) {
        setRecordingTotal3([]);
        setRecordingPaginate({
          pageSize: 6,
          currentPage: 1,
          numPages: "",
          itemCount: "",
          totalElements: "",
        })
        setRecordingTotal(testArr);
      } else {
        setRecordingTotal([]);
      }
      sessionNotesFuntion();
    }
  }, [currentList]);
  const handlePageChange2 = (pageNumber) => {
    // setRecordingPaginate(pageNumber);
    TestpaginateVideo(recordingTotal, 6, pageNumber);
    setRecordingPaginate({
      pageSize: 5,
      currentPage: pageNumber,
      numPages: Math.ceil(recordingTotal?.length / 6),
      itemCount: "",
      totalElements: recordingTotal?.length,
    });
    // newTableFn(pageNumber - 1);
  };
  const handlePageChange3 = (pageNumber) => {
    // setRecordingPaginate(pageNumber);
    Testpaginate(resourcesList, 5, pageNumber);
    setResourcesPaginate({
      pageSize: 5,
      currentPage: pageNumber,
      numPages: Math.ceil(resourcesList?.length / 5),
      itemCount: "",
      totalElements: resourcesList?.length,
    });
    // newTableFn(pageNumber - 1);
  };

  useEffect(() => {
    if (
      resourcesList !== undefined &&
      resourcesList !== null &&
      resourcesList !== "" &&
      resourcesList?.length > 0
    ) {
      setResourcesPaginate({
        pageSize: 5,
        currentPage: 1,
        numPages: Math.ceil(resourcesList?.length / 5),
        itemCount: "",
        totalElements: resourcesList?.length,
      });
      Testpaginate(resourcesList, 5, 1);
    }
  }, [resourcesList]);
  useEffect(() => {
    if (
      recordingTotal !== undefined &&
      recordingTotal !== null &&
      recordingTotal !== "" &&
      recordingTotal?.length > 0
    ) {
      setRecordingPaginate({
        pageSize: 5,
        currentPage: 1,
        numPages: Math.ceil(recordingTotal?.length / 5),
        itemCount: "",
        totalElements: recordingTotal?.length,
      });
      TestpaginateVideo(recordingTotal, 6, 1);
    }
  }, [recordingTotal]);
  const Testpaginate = (array, page_size, page_number) => {
    let arr = array.slice(
      (page_number - 1) * page_size,
      page_number * page_size
    );
    setRecordingTotal2(arr);
  };
  const TestpaginateVideo = (array, page_size, page_number) => {
    let arr = array.slice(
      (page_number - 1) * page_size,
      page_number * page_size
    );
    setRecordingTotal3(arr);
  };

  const getTableDataSearch = () => {
    setActiveText0(true);
    setActiveText(false);
    setActiveText2(false);
    setActiveText3(false);
    setActiveText4(false);
    setActiveText5(false);
    let paramData;
    paramData = {
      id: filterCohortId,
      mentorId: loggedIn?.id,
    };
    api
      .POST(COHORT_PARTICULAR, paramData)
      .then((res) => {
        props?.setHeadingCohort(res?.data?.data?.program_name);
        props?.setIsParentData(res?.data?.data);
      })

      .catch((err) => {});
    // window.open(
    //   `/cohort-programs/cohortView/${item?.cohortId}`,
    //   "_blank"
    // );
    window.history.replaceState(
      {},
      null,
      `/cohort-programs/cohortView/${filterCohortId}`,
      "_blank"
    );
    setCommonCohortId(filterCohortId);
    // window.location.replace(`/cohort-programs/cohortView/${filterCohortId}`);
  };
  // useEffect(() => {
  //   if (
  //     currentList !== undefined &&
  //     currentList !== null &&
  //     currentList !== "" &&
  //     currentList?.length > 0
  //   ) {
  //     if (currentList[0]?.cohortAdminId == loggedIn?.id)
  //       setCohortAdminBoolean(true);
  //     else setCohortAdminBoolean(false);
  //   }
  // }, [currentList]);
  useEffect(() => {
    if (parentData !== undefined && parentData !== null && parentData !== "") {
      if (parentData?.cohort?.cohortAdminId == loggedIn?.id)
        setCohortAdminBoolean(true);
      else setCohortAdminBoolean(false);
    }
  }, [parentData]);
  const testSessionTextVisibility = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");

    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");
    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      return true;
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        return false;
      } else if (sessionDate === presentDate) {
        if (presentTime >= sessionStartTime && endTime >= presentTime) {
          return true;
        } else if (presentTime < sessionStartTime) {
          return true;
        } else {
          return false;
        }
      } else if (presentDate < sessionDate) {
        return true;
      }
    } else if (sessionYear == currentYear && sessionMonth < currentMonth) {
      return false;
    }
  };
  const testClipVisibility = (item) => {
    let testYear = moment(item?.sessionStartDate).format("YYYY");
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let testMonth = moment(item?.sessionStartDate).format("MM");
    if (testYear > currentYear) return false;
    else if (testYear == currentYear && testMonth > currentMonth) return false;
    else
      return (
        moment().format("DD-MM-YYYY HH:mm A") >
          moment(
            moment(
              moment(item?.sessionStartDate).format("DD-MM-YYYY HH:mm A"),
              "DD-MM-YYYY HH:mm A"
            )
              .add(item?.sessionDuration, "hours")
              .format("DD-MM-YYYY HH:mm A"),
            "DD-MM-YYYY HH:mm A"
          )
            .add(60, "minutes")
            .format("DD-MM-YYYY HH:mm A") && item?.sessionStatus === "SCHEDULED"
      );
  };
  const newfunctionTime = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1)
      .subtract(60, "minutes")
      .format("DD-MM-YYYY HH:mm A");
    // let beforetime1 = moment(sessionStartTime, "DD-MM-YYYY HH:mm A")
    //   .subtract(60, "minutes")
    //   .format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionStartTime1)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");
    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      } else if (sessionDate === presentDate) {
        if (presentTime >= beforetime1 && endTime >= presentTime) {
          if (cohortAdminBoolean)
            window.open(item?.vcUrl + "?jwt=" + item?.jwtToken, "_blank");
          else window.open(item?.vcUrl);
        } else if (presentTime < beforetime1) {
          swal({
            title: "Meeting Not Started",
            text: `Cannot join meeting before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        } else {
          swal({
            title: "Scheduled Time Over",
            text: `You cannot join meeting.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        }
      } else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot join meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
    } else if (sessionYear < currentYear) {
      swal({
        title: "Scheduled Time Over",
        text: `You cannot join meeting.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    }
  };
  // useEffect(() => {
  //  if(parentData){

  //   setTimeout(() => {

  //   }, 2000);
  //  }
  // }, [parentData])
  // const downloadFile = async (filePath,fileName) => {
  //   try {
  //     const videoUrl = filePath;
  //     const videoRequest = new Request(videoUrl);
  //    await fetch(videoRequest)
  //       .then(() => {
  //         const link = document.createElement('a');
  //         link.href = videoUrl;
  //         link.setAttribute('download', `${fileName}.mp4`);
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //       });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const downloadFile = async (urls, fileName) => {
    await fetch(urls, {
      method: "GET",
      headers: {
        "Content-Type": "application/mp4",
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.mp4`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
  };

  const sessionNotesFuntion = () => {
    if (currentList?.length > 0) {
      currentList.forEach((item, index) => {
        sessionNotesFileFn(
          item?.cohortGroupSessionId,
          item?.cohortAdminId,
          item?.sessionTitle
        );
      });
    }
  };
  const sessionNotesFileFn = (groupId, cohortAdminId, sessionTitle) => {
    let params = {
      cohortGroupSessionId: groupId,
      addedBy: cohortAdminId,
    };
    api
      .POST(COHORT_SESSION_NOTES_VIEW_FEEDBACK, params)
      .then((res) => {
        let incomingData = res?.data?.data;
        if (
          incomingData?.attachedDoc !== "" &&
          incomingData?.attachedDoc !== undefined &&
          incomingData?.attachedDoc !== null
        ) {
          // if(!resourcesList.includes({url:incomingData?.path,name: item?.title}))
          // if (resourcesList?.length > 0) {
          //   resourcesList.forEach((item, index) => {
          //     if (item?.url != incomingData?.attachedDoc)
          //       setResourcesList((prevState) => [
          //         ...prevState,
          //         {
          //           url: incomingData?.attachedDoc,
          //           name: sessionTitle,
          //         },
          //       ]);
          //   });
          // } else
          let test = true;
          if (resourcesList?.length > 0) {
            resourcesList.forEach((item2, index) => {
              if (item2?.url == incomingData?.attachedDoc)
              test = false
            });
          }
           if(test)
            setResourcesList((prevState) => [
              ...prevState,
              {
                url: incomingData?.attachedDoc,
                name: sessionTitle,
              },
            ]);
        }
        // Testpaginate(resourcesList)
        // setResourcesPaginate({
        //   pageSize: 5,
        //   currentPage: 1,
        //   numPages: Math.ceil(resourcesList?.length / 5),
        //   itemCount: "",
        //   totalElements: resourcesList?.length,
        // })
      })
      .catch((err) => {});
  };

  const handleDateTimeCheck = (item, data) => {
    var today = new Date();

    // today = mm + "/" + dd + "/" + yyyy;
    // let testDate = moment(item?.sessionDate).format("DD/MM/YYYY");
    // var currentTime = new Date().toTimeString().slice(0, 5);

    let currentDay = parseFloat(today.getDate());
    let sessionDay = parseFloat(moment(item?.sessionDate).format("DD"));

    let currentMonth = parseFloat(today.getMonth() + 1);
    let sessionMonth = parseFloat(moment(item?.sessionDate).format("MM"));

    let currentYear = parseFloat(today.getFullYear());
    let sessionYear = parseFloat(moment(item?.sessionDate).format("YYYY"));

    let currentHour = parseFloat(today.getHours());
    let sessionHour =
      parseFloat(item.sessionTime.split(":")[0]) +
      parseFloat(item.sessionDuration) +
      1;
    let currentMinitus = parseFloat(today.getMinutes());
    let sessionMinutes = parseFloat(item.sessionTime.split(":")[1]);
    if (currentYear >= sessionYear) {
      if (currentYear == sessionYear && currentMonth >= sessionMonth) {
        if (currentMonth == sessionMonth && currentDay >= sessionDay) {
          if (currentDay == sessionDay && currentHour >= sessionHour) {
            if (currentHour == sessionHour && currentMinitus > sessionMinutes) {
              setFeedbackMode(false);
              setSessionMomModalOpen(true);
              setSessionMomChildData(data);
            } else {
              if (currentHour > sessionHour) {
                setFeedbackMode(false);
                setSessionMomModalOpen(true);
                setSessionMomChildData(data);
              } else {
                displaySwalWarning();
                let params = {
                  userId: loggedIn?.id,
                  fromInvitationList: false,
                  sessionStatus: selectedStatus,
                  pageFilter: {
                    pageSize: 10,
                    currentPage: 0,
                  },
                };
                listGroupSession(params);
              }
            }
          } else {
            if (currentDay > sessionDay) {
              setFeedbackMode(false);
              setSessionMomModalOpen(true);
              setSessionMomChildData(data);
            } else {
              displaySwalWarning();
              let params = {
                userId: loggedIn?.id,
                fromInvitationList: false,
                sessionStatus: selectedStatus,
                pageFilter: {
                  pageSize: 10,
                  currentPage: 0,
                },
              };
              listGroupSession(params);
            }
          }
        } else {
          if (currentMonth > sessionMonth) {
            setFeedbackMode(false);
            setSessionMomModalOpen(true);
            setSessionMomChildData(data);
          } else {
            displaySwalWarning();
            let params = {
              userId: loggedIn?.id,
              fromInvitationList: false,
              sessionStatus: selectedStatus,
              pageFilter: {
                pageSize: 10,
                currentPage: 0,
              },
            };
            listGroupSession(params);
          }
        }
      } else {
        if (currentYear > sessionYear) {
          setFeedbackMode(false);
          setSessionMomModalOpen(true);
          setSessionMomChildData(data);
        } else {
          displaySwalWarning();
          let params = {
            userId: loggedIn?.id,
            fromInvitationList: false,
            sessionStatus: selectedStatus,
            pageFilter: {
              pageSize: 10,
              currentPage: 0,
            },
          };
          listGroupSession(params);
        }
      }
    } else {
      if (currentYear > sessionYear) {
        setFeedbackMode(false);
        setSessionMomModalOpen(true);
        setSessionMomChildData(data);
      } else {
        displaySwalWarning();
        let params = {
          userId: loggedIn?.id,
          fromInvitationList: false,
          sessionStatus: selectedStatus,
          pageFilter: {
            pageSize: 10,
            currentPage: 0,
          },
        };
        listGroupSession(params);
      }
    }
  };
  const displaySwalWarning = () => {
    swal({
      title: "WARNING",
      text: `You Cannot Complete Session Before Scheduled Time`,
      icon: "info",
    });
    // renderTable();
  };
  const addResourceBox = () => {
    return (
      <div
        className="w-100"
        style={{ cursor: "pointer" }}
        onClick={() => setFileUploadModal(true)}
      >
        <div className="d-flex newuserTooltip flex-column">
          <UploadResource
            width={80}
            height={80}
            style={{ marginLeft: "1.5rem" }}
          />
          <div
            className="documentFooterPdfText"
            style={{
              textAlign: "left",
              marginLeft: "1.5rem",
              whiteSpace: "nowrap",
            }}
          >
            Upload Resource
          </div>
          <span
            className="tooltiptext   tooltip-bottom"
            style={{ left: "40px", top: "120px", width: "200px" }}
          >
            Click to upload resource
          </span>
        </div>
      </div>
    );
  };
  return (
    <>
      <div
        className="admin-bottom-cardNew row mobileviewmentorbelow"
        style={{ padding: "20px" }}
        // style={{marginTop:"8rem",padding: "20px"}}
      >
        <BasicModal
          videoUrl={videoUrl}
          open={showVideo}
          setOpen={setShowVideo}
          videoList={videoArr}
          canDelete={canDelete}
          sessionTitle={sessionTitle}
        />
        <ModalDocUpload
          sendToParent={setUploadDocumentParent}
          modalVisibility={fileUploadModal}
          mentorshipId={""}
          setModalVisibility={setFileUploadModal}
          cohortId={paramsPage?.cohortId}
          parentData={setRefreshPage}
        />
        {modalVisibility2 && (
          <ModalFilter2
            modalVisibility={modalVisibility2}
            setModalVisibility={setModalVisibility2}
            // sendToParent={setIsParentData}
            showPurposeOfMentorship={true}
            fromPage={"startUpDashboard"}
            allCalendarData={true}
            particularCohort={parentData?.cohortId}
          />
        )}
        {sessionMomModalOpen && sessionMomModalOpen === true && (
          <SessionGroupFeedbackModal
            modalVisibility={sessionMomModalOpen}
            setModalVisibility={setSessionMomModalOpen}
            postFeedBack={cohortSessionNotesGiveFeedBack}
            viewMode={feedbackMode} //true if view feedback, false if post feedback
            modalData={sessionMomChildData}
            parentData={setRefreshPage}
            updateStatus={statusGroupSession}
            fromPage={"groupPage"}
            cohortGroupId={cohortGroupSessionId}
            modalData2={sessionModalData}
          />
        )}
        <ModalVisible
          modalOpen={scheduleModalOpen}
          allMentorList={allMentorList}
          allStartupList={allStartupList}
          // mentorshipId={params.mentorshipId}
          setModalOpen={setScheduleModalOpen}
          onBroadcastSelectionChange={onBroadcastSelectionChange}
          setTaggingList={setTaggingList}
          taggingList={taggingList}
          refreshPage={setRefreshPage}
          EditModalValue={false}
          openEditModal={setEditModalVisibility}
          singleCohort={paramsPage?.cohortId}
          // refreshPage={setRefreshPage}
        />
        <SessionsModal
          modalVisibility={sessionModalOpen}
          setModalVisibility={setSessionModalOpen}
          modalData={sessionModalData}
          setModalOpen={setModalOpen}
          openEditModal={setEditModalVisibility}
          parentData={setSessionModalChild}
          fromModule="groupSessions"
          fromPage="invitationPage"
          allMentorList={allMentorList}
          allStartupList={allStartupList}
          onBroadcastSelectionChange={onBroadcastSelectionChange}
          setTaggingList={setTaggingList}
          taggingList={taggingList}
          setShowVideo={setShowVideo}
          setSessionTitle={setSessionTitle}
          setVideoUrl={setVideoUrl}
          setVideoArr={setVideoArr}
        />
        <div className="row ">
          <div
            className="d-flex justify-content-between align-items-center groupsessionheaderdesktop"
            // style={{ position: "relative", left: "-2rem" }}
          >
            <div
              className={
                sessionHoursBtnPressed
                  ? "col-xs-6 col-sm-6 col-md-1 col-lg-"
                  : "resourcesCohortStatus newuserTooltip"
              }
              style={
                sessionHoursBtnPressed
                  ? {
                      position: "relative",
                      left: "2rem",
                      cursor: "default",
                    }
                  : { position: "relative", left: "0rem" }
              }
            >
              <p
                onClick={() => {
                  if (sessionHoursBtnPressed) {
                    // setActiveText0(false);
                    // setActiveText(false);
                    // setActiveText2(false);
                    // setActiveText3(false);
                    // setActiveText4(false);
                    // setActiveText5(false);
                    // getTableDataStatus("");
                    // setSelectedStatus("");
                  } else {
                    setActiveText0(true);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    newTableFnStatus("");
                    setSelectedStatus("");
                    setActivePage(1);
                  }
                }}
                style={{
                  color: activeText0 ? "#277acc" : "#838186",
                  fontSize: "18px",
                  left: "0",
                }}
                className={
                  sessionHoursBtnPressed
                    ? "applicationHeading600001 admindasheaderoptions009"
                    : ""
                }
              >
                {sessionHoursBtnPressed ? "TOTAL HOURS " : `ALL : ${cohortCounter?.totalCount}`}
                {/* {!sessionHoursBtnPressed
                  ? groupSessionCounter !== undefined
                    ? groupSessionCounter.totalCount
                    : 0
                  : parseFloat(cohortCounterData.TillDateTotalHours).toFixed(2)} */}
              </p>
              {!sessionHoursBtnPressed && (
                <span className="tooltiptext   tooltip-bottom group-01">
                  Click to View Total Sessions
                </span>
              )}

              {activeText0 ? (
                <img
                  className="requestStatusBar statusBarLine00"
                  src={LineWithDot}
                  style={{
                    width: "6.8vw",
                    left: "-0.9rem",
                    position: "relative",
                  }}
                />
              ) : (
                ""
              )}
            </div>

            <div
              className={
                sessionHoursBtnPressed
                  ? "col-xs-6 col-sm-6 col-md-1 col-lg-"
                  : "resourcesCohortStatus newuserTooltip"
              }
              style={{ position: "relative", left: "2rem" }}
            >
              <div className="d-flex">
                <div className="resourcesIcons">
                  <FiberManualRecordRounded
                    style={{
                      color: "#b499c7",
                    }}
                  />
                </div>
                <div>
                  <p
                    onClick={() => {
                      if (sessionHoursBtnPressed) {
                        // setActiveText0(false);
                        // setActiveText(false);
                        // setActiveText2(false);
                        // setActiveText3(false);
                        // setActiveText4(false);
                        // setActiveText5(false);
                        // getTableDataStatus("");
                        // setSelectedStatus("");
                      } else {
                        setActiveText0(false);
                        setActiveText(true);
                        setActiveText2(false);
                        setActiveText3(false);
                        setActiveText4(false);
                        setActiveText5(false);
                        setActivePage(1);
                        newTableFnStatus("SCHEDULED");
                        setSelectedStatus("SCHEDULED");
                      }
                    }}
                    style={{
                      color: activeText ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className={
                      sessionHoursBtnPressed
                        ? "applicationHeading600001 admindasheaderoptions009"
                        : ""
                    }
                  >
                    SCHEDULED : {cohortCounter?.scheduledCount}
                    {/* {!sessionHoursBtnPressed
                      ? groupSessionCounter !== undefined
                        ? groupSessionCounter.scheduledCount
                        : 0
                      : parseFloat(
                          cohortCounterData?.TillDateScheduledHours?.toFixed(2)
                        )} */}
                  </p>
                  {!sessionHoursBtnPressed && (
                    <span className="tooltiptext   tooltip-bottom group-02">
                      Click to View Scheduled Sessions
                    </span>
                  )}
                </div>
              </div>

              {activeText ? (
                <img
                  className="requestStatusBar statusBarLine00"
                  src={LineWithDot}
                  style={{
                    width: "11.4vw",
                    left: "0.1rem",
                    position: "relative",
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div
              className={
                sessionHoursBtnPressed
                  ? "col-xs-6 col-sm-6 col-md-1 col-lg-"
                  : "resourcesCohortStatus newuserTooltip"
              }
              style={{ position: "relative", left: "0.75rem" }}
            >
              <div className="d-flex">
                <div className="resourcesIcons">
                  <FiberManualRecordRounded
                    style={{
                      color: "#92a9b0",
                    }}
                  />
                </div>
                <div>
                  <p
                    onClick={() => {
                      if (sessionHoursBtnPressed) {
                        // setActiveText0(false);
                        // setActiveText(false);
                        // setActiveText2(false);
                        // setActiveText3(false);
                        // setActiveText4(false);
                        // setActiveText5(false);
                        // getTableDataStatus("");
                        // setSelectedStatus("");
                      } else {
                        setActiveText0(false);
                        setActiveText2(true);
                        setActiveText(false);
                        setActiveText3(false);
                        setActiveText4(false);
                        setActiveText5(false);
                        newTableFnStatus("COMPLETED");
                        getTableDataStatus("COMPLETED");
                        setActivePage(1);
                      }
                    }}
                    style={{
                      color: activeText2 ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className={
                      sessionHoursBtnPressed
                        ? "applicationHeading600001 admindasheaderoptions009"
                        : ""
                    }
                  >
                    COMPLETED : {cohortCounter?.completedCount}
                    {/* {!sessionHoursBtnPressed
                      ? groupSessionCounter !== undefined
                        ? groupSessionCounter.completedCount
                        : 0
                      : parseFloat(
                          cohortCounterData.TillDateCompletedHours
                        )?.toFixed(2)} */}
                  </p>
                  {!sessionHoursBtnPressed && (
                    <span className="tooltiptext   tooltip-bottom group-03">
                      Click to View Completed Sessions
                    </span>
                  )}
                </div>
              </div>
              {activeText2 ? (
                <img
                  className="requestStatusBar positionBar000"
                  src={LineWithDot}
                  style={{
                    width: "12.2vw",
                    left: "0.2rem",
                    position: "relative",
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div
              className={
                sessionHoursBtnPressed
                  ? "col-xs-6 col-sm-6 col-md-1 col-lg-"
                  : "resourcesCohortStatus newuserTooltip"
              }
              style={{ position: "relative", left: "0.75rem" }}
            >
              <div className="d-flex">
                <div className="resourcesIcons">
                  {" "}
                  <FiberManualRecordRounded
                    style={{
                      color: "#7784d8",
                    }}
                  />
                </div>
                <div>
                  <p
                    onClick={() => {
                      if (sessionHoursBtnPressed) {
                        // setActiveText0(false);
                        // setActiveText(false);
                        // setActiveText2(false);
                        // setActiveText3(false);
                        // setActiveText4(false);
                        // setActiveText5(false);
                        // getTableDataStatus("");
                        // setSelectedStatus("");
                      } else {
                        setActiveText0(false);
                        setActiveText2(false);
                        setActiveText(false);
                        setActiveText3(false);
                        setActiveText4(true);
                        setActiveText5(false);
                        newTableFnStatus("CLOSED");
                        getTableDataStatus("CLOSED");
                        setActivePage(1);
                      }
                    }}
                    style={{
                      color: activeText4 ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className={
                      sessionHoursBtnPressed
                        ? "applicationHeading600001 admindasheaderoptions009"
                        : ""
                    }
                  >
                    CLOSED : {cohortCounter?.closedCount}
                    {/* {!sessionHoursBtnPressed
                      ? groupSessionCounter !== undefined
                        ? groupSessionCounter.closedCount
                        : 0
                      : parseFloat(
                          cohortCounterData.TillDateCompletedHours
                        )?.toFixed(2)} */}
                  </p>
                  {!sessionHoursBtnPressed && (
                    <span className="tooltiptext   tooltip-bottom group-03">
                      Click to View Closed Sessions
                    </span>
                  )}
                </div>
              </div>
              {activeText4 ? (
                <img
                  className="requestStatusBar positionBar000"
                  src={LineWithDot}
                  style={{
                    width: "10.2vw",
                    left: "-0.9rem",
                    position: "relative",
                  }}
                />
              ) : (
                ""
              )}
            </div>

            <div
              className={
                sessionHoursBtnPressed
                  ? "col-xs-6 col-sm-6 col-md-1 col-lg-"
                  : "resourcesCohortStatus newuserTooltip"
              }
              style={{ position: "relative", right: "1rem" }}
            >
              <div className="d-flex">
                <div className="resourcesIcons">
                  <FiberManualRecordRounded
                    style={{
                      color: "#d07979",
                    }}
                  />
                </div>
                <div>
                  <p
                    onClick={() => {
                      if (sessionHoursBtnPressed) {
                        // setActiveText0(false);
                        // setActiveText(false);
                        // setActiveText2(false);
                        // setActiveText3(false);
                        // setActiveText4(false);
                        // setActiveText5(false);
                        // getTableDataStatus("");
                        // setSelectedStatus("");
                      } else {
                        setActiveText0(false);
                        setActiveText2(false);
                        setActiveText(false);
                        setActiveText3(true);
                        setActiveText4(false);
                        setActiveText5(false);
                        newTableFnStatus("CANCELLED");
                        getTableDataStatus("CANCELLED");
                        setActivePage(1);
                      }
                    }}
                    style={{
                      color: activeText3 ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className={
                      sessionHoursBtnPressed
                        ? "applicationHeading600001 admindasheaderoptions009"
                        : ""
                    }
                  >
                    CANCELLED : {cohortCounter?.cancelledCount}
                    {/* {!sessionHoursBtnPressed
                      ? groupSessionCounter !== undefined
                        ? groupSessionCounter.cancelledCount
                        : 0
                      : parseFloat(
                          cohortCounterData.tilldateCanceledHourTotal
                        )?.toFixed(2)} */}
                  </p>
                  {!sessionHoursBtnPressed && (
                    <span className="tooltiptext   tooltip-bottom group-04">
                      Click to View Canceled Sessions
                    </span>
                  )}
                </div>
              </div>
              {activeText3 ? (
                <img
                  className="requestStatusBar positionBar000"
                  src={LineWithDot}
                  style={{
                    width: "11.2vw",
                    left: "0.1rem",
                    // left: "1.1rem",
                    position: "relative",
                  }}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {/* <div className="groupsessionheadermobile">
              <div
                className="resourcesCohortStatus newuserTooltip sessionheadermobile1"
                style={{ position: "relative", left: "2rem" }}
              >
                <p
                  onClick={() => {
                    setActiveText0(true);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    getTableDataStatus("");
                    setSelectedStatus("");
                  }}
                  style={{
                    color: activeText0 ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className=""
                >
                  TOTAL SESSIONS :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.totalCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-01">
                  Click to View Total Sessions
                </span>
                {activeText0 ? (
                  <img
                    className="requestStatusBar statusBarLine00"
                    src={LineWithDot}
                    style={{
                      width: "12.8vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>

              <div
                className="resourcesCohortStatus newuserTooltip sessionheadermobile2"
                style={{ position: "relative", left: "2rem" }}
              >
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText(true);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    getTableDataStatus("SCHEDULED");
                    setSelectedStatus("SCHEDULED");
                  }}
                  style={{
                    color: activeText ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className=""
                >
                  SCHEDULED :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.scheduledCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-02">
                  Click to View Scheduled Sessions
                </span>
                {activeText ? (
                  <img
                    className="requestStatusBar statusBarLine00"
                    src={LineWithDot}
                    style={{
                      width: "10.4vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="resourcesCohortStatus newuserTooltip sessionheadermobile3"
                style={{ position: "relative", left: "0.75rem" }}
              >
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText2(true);
                    setActiveText(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    setSelectedStatus("COMPLETED");
                    getTableDataStatus("COMPLETED");
                  }}
                  style={{
                    color: activeText2 ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className=""
                >
                  COMPLETED :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.completedCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-03">
                  Click to View Completed Sessions
                </span>
                {activeText2 ? (
                  <img
                    className="requestStatusBar positionBar000"
                    src={LineWithDot}
                    style={{
                      width: "10.2vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="resourcesCohortStatus newuserTooltip sessionheadermobile4"
                style={{ position: "relative", right: "1rem" }}
              >
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText2(false);
                    setActiveText(false);
                    setActiveText3(true);
                    setActiveText4(false);
                    setActiveText5(false);
                    setSelectedStatus("CANCELLED");
                    getTableDataStatus("CANCELLED");
                  }}
                  style={{
                    color: activeText3 ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className=""
                >
                  CANCELLED :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.cancelledCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-04">
                  Click to View Canceled Sessions
                </span>
                {activeText3 ? (
                  <img
                    className="requestStatusBar positionBar000"
                    src={LineWithDot}
                    style={{
                      width: "9.8vw",
                      left: "-0.9rem",
                      // left: "1.1rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div> */}
      </div>
      <div className="filter-row filter-row-common filterDivMentorapp">
        <div>
          <form className="">
            <div
              className="row desktopFilterRow"
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "row",
                paddingLeft: "10px",
              }}
            >
              <div className="d-flex  filtergroupsession">
                {/* {cohortAdminBoolean && (
                  <div className="d-flex">
                    <div
                      className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame"
                      style={{ marginRight: "10px !important" }}
                    >
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                              cohortId: null,
                            };
                          });
                          setFilterCohortId(e.value);
                          if (e.value === "select" || e.value === "Select")
                            setSearchCohortId("");
                          else setSearchCohortId(e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "150px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>

                    <div
                      className="apply-section d-flex sessiongobtn"
                      style={{ marginLeft: "1rem" }}
                    >
                      <div className="newuserTooltip">
                        <Button
                          onClick={getTableDataSearch}
                          text="GO"
                          className="filter-button top-btn newcoloredbtn startupColorBtn"
                          style={{ minHeight: "3rem" }}
                        ></Button>
                        <span className="tooltiptext filterAdmin  tooltip-bottom filterAfter">
                          Click to Apply Filters
                        </span>
                      </div>
                    </div>
                  </div>
                )} */}
                {/* <div className="cohortSessionListMiddle">
                      <div
                        style={{ cursor: "pointer" }}
                        className={
                          selectedStatus == ""
                            ? "calendarStatusBtnActive newuserTooltip"
                            : "calendarStatusBtn newuserTooltip"
                        }
                        // class="newuserTooltip"
                        onClick={() => {
                          setSelectedStatus("");
                          getTableDataStatus("");
                        }}
                      >
                        All
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{
                            // left: "165px",
                            // top: "196px",
                            width: "150px",
                            position: "absolute",
                            left: "2px",
                          }}
                        >
                          View All Session
                        </span>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="d-flex sessionListSpacing newuserTooltip"
                        onClick={() => {
                          setSelectedStatus("SCHEDULED");
                          getTableDataStatus("SCHEDULED");
                        }}
                      >
                        {" "}
                        <FiberManualRecordRounded
                          style={{
                            color: "#b499c7",
                          }}
                        />
                        <div
                          className={
                            selectedStatus == "SCHEDULED"
                              ? "calendarStatusBtnActive"
                              : "calendarStatusBtn"
                          }
                        >
                          Scheduled
                        </div>
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{
                            // left: "165px",
                            // top: "196px",
                            width: "175px",
                            position: "absolute",
                            left: "2px",
                          }}
                        >
                          View Scheduled Sessions
                        </span>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="d-flex sessionListSpacing newuserTooltip"
                        onClick={() => {
                          setSelectedStatus("COMPLETED");
                          getTableDataStatus("COMPLETED");
                        }}
                      >
                        {" "}
                        <FiberManualRecordRounded
                          style={{
                            color: "#92a9b0",
                          }}
                        />
                        <div
                          className={
                            selectedStatus == "COMPLETED"
                              ? "calendarStatusBtnActive"
                              : "calendarStatusBtn"
                          }
                        >
                          Completed
                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              // left: "165px",
                              // top: "196px",
                              width: "195px",
                              position: "absolute",
                              left: "2px",
                            }}
                          >
                            View Completed Sessions
                          </span>
                        </div>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="d-flex sessionListSpacing newuserTooltip"
                        onClick={() => {
                          setSelectedStatus("CLOSED");
                          getTableDataStatus("CLOSED");
                        }}
                      >
                        {" "}
                        <FiberManualRecordRounded
                          style={{
                            color: "#7784d8",
                          }}
                        />
                        <div
                          className={
                            selectedStatus == "CLOSED"
                              ? "calendarStatusBtnActive"
                              : "calendarStatusBtn"
                          }
                        >
                          Closed
                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              // left: "165px",
                              // top: "196px",
                              width: "195px",
                              position: "absolute",
                              left: "2px",
                            }}
                          >
                            View Closed Sessions
                          </span>
                        </div>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="d-flex sessionListSpacing newuserTooltip"
                        onClick={() => {
                          setSelectedStatus("CANCELLED");
                          getTableDataStatus("CANCELLED");
                        }}
                      >
                        {" "}
                        <FiberManualRecordRounded
                          style={{
                            color: "#d07979",
                          }}
                        />
                        <div
                          className={
                            selectedStatus == "CANCELLED"
                              ? "calendarStatusBtnActive"
                              : "calendarStatusBtn"
                          }
                        >
                          Canceled
                        </div>
                        <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              // left: "165px",
                              // top: "196px",
                              width: "195px",
                              position: "absolute",
                              left: "2px",
                            }}
                          >
                            View Canceled Sessions
                          </span>
                      </div>
                    </div> */}
                {/* <div
                      className="dashboard-bottom-btn top-btn  newuserTooltip "
                      onClick={() => setScheduleModalOpen(true)}
                    >
                      <p
                        style={{
                          cursor: "pointer",
                          color: "white",
                          position: "relative",
                          top: "-5px",
                          fontSize: "16px",
                        }}
                        className="createcohortsessionbtnpara"
                      >
                        CREATE COHORT SESSION
                      </p>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "150px", top: "60px", width: "220px" }}
                      >
                        Click to Create a Cohort Session
                      </span>
                    </div> */}
                {parentData?.cohort?.cohortStatus !== undefined &&
                  parentData?.cohort?.cohortStatus == "CLOSED" && (
                    <div class="d-flex justify-content-end fixedMessageSticky">
                      <div
                        class="fixedMessageStickyText2"
                        style={{ fontSize: "1.25rem" }}
                      >
                        This Cohort is Closed
                      </div>
                    </div>
                  )}
                <div className="newButtonsEndRow">
                  <div
                    className="dashboard-bottom-btn top-btn  newuserTooltip "
                    onClick={() => setModalVisibility2(true)}
                  >
                    <p
                      style={{
                        cursor: "pointer",
                        color: "white",
                        position: "relative",
                        top: "-1.2rem",
                        fontSize: "16px",
                      }}
                      className="createcohortsessionbtnpara"
                    >
                      COHORTS EVENTS CALENDAR
                    </p>
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "150px", top: "60px", width: "250px" }}
                    >
                      Click to View Cohorts Event Calendar
                    </span>
                  </div>

                  {cohortAdminBoolean &&
                    parentData?.cohort?.cohortStatus !== undefined &&
                    parentData?.cohort?.cohortStatus !== "CLOSED" && (
                      <div
                        className="dashboard-bottom-btn top-btn  newuserTooltip "
                        onClick={() => setScheduleModalOpen(true)}
                        style={{ marginLeft: "10px" }}
                      >
                        <p
                          style={{
                            cursor: "pointer",
                            color: "white",
                            position: "relative",
                            top: "-0px",
                            fontSize: "16px",
                          }}
                          className="createcohortsessionbtnpara"
                        >
                          CREATE COHORT SESSION
                        </p>
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{
                            left: "150px",
                            top: "60px",
                            width: "220px",
                          }}
                        >
                          Click to Create a Cohort Session
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {currentListPaginate !== undefined &&
        currentListPaginate !== "" &&
        currentListPaginate !== null && (
          <div className="totalTableCount3">
            Total Cohort Sessions : {currentListPaginate?.totalElements} &lt;{" "}
            {currentListPaginate?.currentPage} of{" "}
            {currentListPaginate?.numPages} &gt;{" "}
          </div>
        )}

      {currentList && currentList?.length > 0 ? (
        <div className="parentRow">
          {currentList.map((item, index) => (
            <div className="childColumn">
              <div
                className={
                  item?.recordings !== undefined &&
                  item?.recordings !== null &&
                  item?.recordings !== "" &&
                  item?.recordings?.length > 0
                    ? "headerSectionCardV25"
                    : "headerSectionCardV22"
                }
              >
                <div
                  className="cohortSessionHeader"
                  style={{
                    backgroundColor: `${colorTester(item?.sessionStatus)}`,
                  }}
                ></div>
                <div className="cohortSessionTitle">{item?.sessionTitle}</div>
                <div className="cohortSessionContent">
                  {/* <div className="cohortSessionContentItem">
                  Cohort Name -{" "}
                  <span className="cohortSessionContentItem2">
                    {item?.cohortApplication?.program_name}
                  </span>
                </div> */}

                  <div className="cohortSessionContentItem d-flex">
                    <div style={{ width: "35%" }}>Date & Time </div>
                    <div className="cohortSessionContentItem2">
                      {" "}
                      {dateFormat(
                        moment(item?.sessionStartDate).format("DD/MM/YYYY")
                      )}
                      [{moment(item?.sessionStartDate).format("hh:mm a")}{" "}
                      {moment
                        .tz(
                          item?.sessionStartDate,
                          Intl.DateTimeFormat().resolvedOptions().timeZone
                        )
                        .format("z")
                        .includes("-")
                        ? "GMT" +
                          moment
                            .tz(
                              item?.sessionStartDate,
                              Intl.DateTimeFormat().resolvedOptions().timeZone
                            )
                            .format("z")
                        : moment
                            .tz(
                              item?.sessionStartDate,
                              Intl.DateTimeFormat().resolvedOptions().timeZone
                            )
                            .format("z")}
                      ]
                    </div>
                  </div>
                  <div className="cohortSessionContentItem d-flex mt-1">
                    <div style={{ width: "35%" }}>Duration</div>
                    <div className="cohortSessionContentItem2">
                      {roundUP(item?.sessionDuration, 2)} hrs
                    </div>
                  </div>
                  <div className="cohortSessionContentItem d-flex mt-1">
                    <div style={{ width: "35%" }}>
                      Speakers {`(${item?.speakerUserList?.length})`}
                    </div>
                    <div
                      style={{ display: "inline-grid" }}
                      className="cohortSessionContentItem2"
                    >
                      {item?.speakerUserList?.length > 0 &&
                        item?.speakerUserList.map((speakerItem) => {
                          return (
                            <>
                              <div
                                className="newuserTooltip d-flex sessionListMentor"
                                onClick={() => {
                                  ViewProfile(
                                    speakerItem?.id,
                                    speakerItem?.applicant_name
                                  );
                                }}
                              >
                                {speakerItem?.applicant_name}
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    top: "35px",
                                    width: "150px",
                                    position: "absolute",
                                    left: "50px",
                                  }}
                                >
                                  View Mentor Profile
                                </span>
                              </div>
                              {/* <span>{speakerItem?.applicant_name}</span> */}
                            </>
                          );
                        })}
                    </div>
                  </div>
                  <div className="cohortSessionContentItem d-flex mt-1">
                    <div style={{ width: "35%" }}>Organization</div>
                    <div className="cohortSessionContentItem2">
                      {item?.cohortUserDetail?.organization_name}
                    </div>
                  </div>
                  {/* <div>
                      Goal - <span>{item?.sessionTitle}</span>
                    </div> */}
                  {item?.totalParticipant > 0 && (
                    <div className="cohortSessionContentItem mt-1 d-flex">
                      <div style={{ width: "35%" }}>
                        {item?.sessionStatus == "SCHEDULED"
                          ? "Total Invited"
                          : "Total Attendees"}{" "}
                      </div>
                      <div className="cohortSessionContentItem2">
                        {item?.totalParticipant}
                      </div>
                    </div>
                  )}
                  <div className="cohortSessionContentItem mt-1 mb-5 d-flex">
                    <div style={{ width: "50%" }}>Created By</div>
                    <div
                      className="newuserTooltip d-flex sessionListMentor"
                      onClick={() => {
                        ViewProfile(
                          item?.cohortUserDetail?.id,
                          item?.cohortUserDetail?.applicant_name
                        );
                      }}
                      style={{ position: "relative", left: "5px" }}
                    >
                      {" "}
                      {item?.cohortUserDetail?.applicant_name}
                      <span
                        className="tooltiptext tooltip-bottom "
                        style={{
                          top: "35px",
                          width: "150px",
                          position: "absolute",
                          left: "50px",
                        }}
                      >
                        View Mentor Profile
                      </span>
                    </div>
                  </div>
                
                  {/* )} */}
                  
                </div>
              </div>

              <div
                className="d-flex footerCohortV23"
                // style={{ width: "100%", justifyContent: "space-between",paddingLeft:"5%",paddingRight:"3%" }}
              >
                <div className="d-flex" style={{gap:"20px"}}>
                  {testSessionTextVisibility(item) && 
                   item?.sessionStatus !== "CANCELLED" &&(
                    <div>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="d-flex newAboutExitBtn42 newuserTooltip"
                          onClick={() => {
                            // window.open(
                            //   item?.vcUrl + "?jwt=" + item?.jwtToken,
                            //   "_blank"
                            // );

                            newfunctionTime(item);
                          }}
                        >
                          Join
                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              left: "15px",
                              top: "30px",
                              width: "305px",
                              height: "45px",
                              textWrap: "balance",
                            }}
                          >
                            All Chats and Video Discussions may be recorded for
                            quality purposes
                          </span>
                        </div>
                        <div>
                          <div
                            className="d-flex justify-content-end newuserTooltip"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              // navigator.clipboard.writeText(item.vcUrl);
                              setLinkToogleCopy(true);
                              // setClipBoardData(item)
                              // getSessionDetails(item?.cohortGroupSessionId);
                              //      navigator.clipboard.writeText(
                              //   `Meeting at : ${moment(
                              //     item.sessionDate
                              //   ).format(
                              //     "DD-MM-YYYY"
                              //   )} ${item?.sessionTime}\nDuration (Hours): ${
                              //     item?.sessionDuration
                              //   }\nJoin MAARG Meeting:\n${item?.vcUrl}`
                              // )
                              navigator.clipboard.writeText(
                                `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                  item?.sessionStartDate
                                ).format("MMM. D, YYYY")} ${moment(
                                  item.sessionStartDate
                                ).format("hh:mm a")} (${
                                  moment
                                    .tz(
                                      item?.sessionStartDate,
                                      Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                                    )
                                    .format("z")
                                    .includes("-")
                                    ? "GMT" +
                                      moment
                                        .tz(
                                          item?.sessionStartDate,
                                          Intl.DateTimeFormat().resolvedOptions()
                                            .timeZone
                                        )
                                        .format("z")
                                    : moment
                                        .tz(
                                          item?.sessionStartDate,
                                          Intl.DateTimeFormat().resolvedOptions()
                                            .timeZone
                                        )
                                        .format("z")
                                })
                                                  \nDuration (Hours): ${
                                                    item?.sessionDuration
                                                  }\n\nJoin MAARG Meeting:\n${
                                  item?.vcUrl
                                }`
                              );

                              setLinkToogleText(
                                "Your MAARG Session Link is copied"
                              );
                            }}
                          >
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={
                                linkToggleCopy
                                  ? {
                                      left: "-35px",
                                      top: "30px",
                                      width: "240px",
                                      backgroundColor: "rgb(184,153,207)",
                                    }
                                  : {
                                      left: "-35px",
                                      top: "30px",
                                      width: "240px",
                                      backgroundColor: "#816ab0",
                                    }
                              }
                            >
                              {linkToggleText}
                            </span>
                            <ContentCopyIcon />
                          </div>
                          <div
                            className="d-flex mt-2"
                            style={{ justifyContent: "space-between" }}
                          >
                            {testClipVisibility(item)
                              ? ""
                              : cohortAdminBoolean && (
                                  <div
                                    className="d-flex justify-content-end newuserTooltip"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      // navigator.clipboard.writeText(item.vcUrl);
                                      setLinkToogleCopyModerator(true);
                                      // setClipBoardData(item)
                                      // getSessionDetails(item?.cohortGroupSessionId);
                                      //      navigator.clipboard.writeText(
                                      //   `Meeting at : ${moment(
                                      //     item.sessionDate
                                      //   ).format(
                                      //     "DD-MM-YYYY"
                                      //   )} ${item?.sessionTime}\nDuration (Hours): ${
                                      //     item?.sessionDuration
                                      //   }\nJoin MAARG Meeting:\n${item?.vcUrl}`
                                      // )
                                      navigator.clipboard.writeText(
                                        `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                          item?.sessionStartDate
                                        ).format("MMM. D, YYYY")} ${moment(
                                          item.sessionStartDate
                                        ).format("hh:mm a")} (${
                                          moment
                                            .tz(
                                              item?.sessionStartDate,
                                              Intl.DateTimeFormat().resolvedOptions()
                                                .timeZone
                                            )
                                            .format("z")
                                            .includes("-")
                                            ? "GMT" +
                                              moment
                                                .tz(
                                                  item?.sessionStartDate,
                                                  Intl.DateTimeFormat().resolvedOptions()
                                                    .timeZone
                                                )
                                                .format("z")
                                            : moment
                                                .tz(
                                                  item?.sessionStartDate,
                                                  Intl.DateTimeFormat().resolvedOptions()
                                                    .timeZone
                                                )
                                                .format("z")
                                        })
                                                  \nDuration (Hours): ${
                                                    item?.sessionDuration
                                                  }\n\nJoin MAARG Meeting:\n${
                                          item?.vcUrl + "?jwt=" + item?.jwtToken
                                        }`
                                      );

                                      setLinkToogleTextModerator(
                                        "Your MAARG Session Moderator Link is copied"
                                      );
                                    }}
                                  >
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={
                                        linkToggleCopyModerator
                                          ? {
                                              left: "-10rem",
                                              top: "30px",
                                              width: "350px",
                                              backgroundColor:
                                                "rgb(184,153,207)",
                                            }
                                          : {
                                              left: "-10rem",
                                              top: "30px",
                                              width: "350px",
                                              backgroundColor: "#816ab0",
                                            }
                                      }
                                    >
                                      {linkToggleTextModerator}
                                    </span>
                                    <img
                                      src={ModeratorCopy}
                                      height={30}
                                      width={30}
                                      style={{
                                        position: "relative",
                                        left: "10.25%",
                                      }}
                                    />
                                  </div>
                                )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {item?.recordings !== undefined &&
                    item?.recordings !== null &&
                    item?.recordings !== "" &&
                    item?.recordings?.length > 0 && (
                      <div
                        className="d-flex newAboutExitBtn423 mt-1 newuserTooltip"
                        onClick={() => {
                          handleView(
                            item?.recording,
                            item?.recordings,
                            item?.cohortAdminId,
                            item?.sessionTitle
                          );
                        }}
                      >
                        Recordings
                        <span
                          className="tooltiptext   tooltip-bottom group-01"
                          style={{
                            width: "9rem",
                            position: "relative",
                            left: "-2rem",
                            top: "2rem",
                          }}
                        >
                          View Recordings
                        </span>
                      </div>
                    )}
                 
                      {!item?.isNotesSubmitted &&
                  !testSessionTextVisibility(item) &&
                  item?.sessionStatus !== "CANCELLED" &&
                  cohortAdminBoolean ? (
                    <div className="mt-1">
                      {/* {!item?.isNotesSubmitted ? ( */}
                      <div
                        className="d-flex justify-content-left newuserTooltip"
                        style={{ cursor: "pointer" }}
                      >
                        <a
                          id="myLink"
                          href={"Javascript:void(0)"}
                          className="color-green"
                          style={{
                            fontSize: "14px",
                            marginBottom: "1.25rem",
                          }}
                          onClick={() => {
                            let obj = {
                              sessionDate: item?.sessionDate,
                              sessionTime: item?.sessionTime,
                              cohortGroupSessionId: item?.cohortGroupSessionId,
                              sessionDuration: item?.sessionDuration,
                            };
                            // getSessionDetails(item?.cohortGroupSessionId);
                            handleDateTimeCheck(obj, item);

                            // setFeedbackMode(false);
                            // setSessionMomModalOpen(true);
                            // setSessionMomChildData(item);
                            // window.open(item?.vcUrl + "?jwt=" + item?.jwtToken, "_blank");
                            // newfunctionTime(item);
                          }}
                        >
                          Mark as Complete
                        </a>
                        <span
                          className="tooltiptext   tooltip-bottom group-01"
                          style={{
                            width: "9rem",
                            position: "relative",
                            left: "-2rem",
                            top: "2rem",
                          }}
                        >
                          Click to Fill Notes
                        </span>
                      </div>
                    </div>
                  ) : (
                    item?.isNotesSubmitted && (
                      <div
                        className="d-flex justify-content-left newuserTooltip mt-1"
                        style={{ cursor: "pointer" }}
                      >
                        <a
                          id="myLink"
                          href={"Javascript:void(0)"}
                          className="color-green"
                          style={{
                            fontSize: "14px",
                            marginBottom: "1.25rem",
                          }}
                          onClick={() => {
                            setCohortGroupSessionId(item?.cohortGroupSessionId);
                            setFeedbackMode(true);
                            let params = {
                              cohortGroupSessionId: item?.cohortGroupSessionId,
                              addedBy: item?.cohortAdminId,
                            };
                            cohortSessionNotesViewFeedBack(params);
                            setTimeout(() => {
                              setSessionMomModalOpen(true);
                            }, 1000);
                            // setFeedbackMode(false);
                            // setSessionMomModalOpen(true);
                            // setSessionMomChildData(item);
                            // window.open(item?.vcUrl + "?jwt=" + item?.jwtToken, "_blank");
                            // newfunctionTime(item);
                          }}
                        >
                          View Notes
                        </a>
                        <span
                          className="tooltiptext   tooltip-bottom group-01"
                          style={{
                            width: "9rem",
                            position: "relative",
                            left: "-2rem",
                            top: "2rem",
                          }}
                        >
                          View Session Notes
                        </span>
                      </div>
                    )
                  )}
                </div>
                <div>
                  {/* <div>
                  <img src={StarIcon} />
                    </div> */}
                  <div
                    className="informationCardButton newuserTooltip"
                    onClick={() => {
                      setSessionModalOpen(true);
                      getSessionDetails(item?.cohortGroupSessionId);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-info-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                    </svg>
                    {/* <img src={infoButton} /> */}
                    <span
                      className="tooltiptext   tooltip-bottom group-01 top-btn"
                      style={{ left: "0rem", top: "2rem", width: "150px" }}
                    >
                      View Session Details
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="emptyListCohort">No records found</div>
      )}

      <div className="pagination-box">
        {currentListPaginate !== undefined &&
          currentListPaginate !== "" &&
          currentListPaginate !== null && (
            <Pagination
              activePage={activePage}
              itemsCountPerPage={6}
              totalItemsCount={currentListPaginate.totalElements}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />
          )}
      </div>
      <div>
        <div className="d-flex footerButtonText mt-2">Session Recordings</div>
       
        {/* {recordingTotal3 !== "" &&
        recordingTotal3 !== undefined &&
        recordingTotal3 !== null &&
        recordingTotal3?.length > 0 ? (
          <div>
            {recordingPaginate !== undefined &&
              recordingPaginate !== null &&
              recordingPaginate !== "" && (
                <div
                  className="totalTableCount3"
                  style={{ marginBottom: "1.3rem" }}
                >
                  {
                    console.log("recordingPaginate",recordingPaginate)
                  }
                  Total Session Recordings : {recordingPaginate?.totalElements}{" "}
                  &lt; {recordingPaginate?.currentPage} of{" "}
                  {recordingPaginate?.numPages} &gt;{" "}
                </div>
              )}
  
            <div
              className="downloadsResourcesBox mt-2"
              // style={{ display: "flex", gap: "20px" }}
            >
               
              {recordingTotal3.map((item, index) => {
                return (
                  <div>
                    <div className="d-flex">
                      <div
                        style={{
                          backgroundColor: "#000000",
                          width: "fit-content",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          className="documentBackgroundImg"
                          src={item?.videoUrl}
                          onClick={() => {
                            handleView(item?.videoUrl, "", "");
                          }}
                          style={{
                            backgroundColor: "#000000",
                            width: "fit-content",
                            borderRadius: "10px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <div className="d-flex recordingImg">
                        <img
                          src={PlayButton}
                          onClick={() => {
                            handleView(item?.videoUrl, "", "");
                          }}
                          style={{
                            backgroundColor: "#000000",
                            width: "fit-content",
                            borderRadius: "10px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                     
                    </div>
                    <div className="documentFooterPdfText">
                      {item?.videoSessionTitle}
                    </div>
                    <div className="documentFooterPdfText">
                      {item?.videoSessionNo}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="pagination-box">
              <Pagination
                activePage={recordingPaginate?.currentPage}
                itemsCountPerPage={6}
                totalItemsCount={recordingPaginate?.totalElements}
                pageRangeDisplayed={5}
                onChange={handlePageChange2.bind(this)}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="emptyListCohort">No recordings found</div>
          </>
        )} */}

        {recordingTotal3 !== "" &&
        recordingTotal3 !== undefined &&
        recordingTotal3 !== null &&
        recordingTotal3?.length > 0 ? (
          <div>
            <div
              className="downloadsResourcesBox mt-4"
              // style={{ display: "flex", gap: "20px" }}
            >
              {recordingTotal3.map((item, index) => {
                return (
                  <div>
                    <div className="d-flex">
                      <div
                        style={{
                          backgroundColor: "#000000",
                          width: "fit-content",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          className="documentBackgroundImg"
                          src={item?.videoUrl}
                          onClick={() => {
                            handleView(
                              item?.recording,
                              item?.recordings,
                              item?.cohortAdminId,
                              item?.sessionTitle
                            );
                          }}
                          style={{
                            backgroundColor: "#000000",
                            width: "fit-content",
                            borderRadius: "10px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <div className="d-flex recordingImg">
                        <img
                          src={PlayButton}
                          onClick={() => {
                            handleView(
                              item?.recording,
                              item?.recordings,
                              item?.cohortAdminId,
                              item?.sessionTitle
                            );
                          }}
                          style={{
                            backgroundColor: "#000000",
                            width: "fit-content",
                            borderRadius: "10px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                    <div className="documentFooterPdfText">
                      {item?.sessionTitle}
                    </div>
                  </div>
                  
                );
              })}
            </div>
              
            <div className="pagination-box">
              <Pagination
                activePage={recordingPaginate?.currentPage}
                itemsCountPerPage={6}
                totalItemsCount={recordingPaginate?.totalElements}
                pageRangeDisplayed={5}
                onChange={handlePageChange2.bind(this)}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="emptyListCohort">No recordings found</div>
          </>
        )}
        <div
          className="d-flex"
          style={{ width: "20%", justifyContent: "space-between" }}
        >
          <div className="footerButtonText">Resources</div>
          <div>
            {/* <img
                                      className="newCohortImgBtn"
                                      src={DownloadButton}
                                    /> */}
            {/* <div className="footerButtonDownload top-btn">
            
              <div>Download All</div>
            </div> */}
          </div>
        </div>
        {
          console.log("parentData",parentData)
        }
        <div className="d-flex mt-2 flex-column">
          {recordingTotal2?.length == 0 &&
            (cohortAdminBoolean || loginrole == "Admin") &&
            parentData?.cohort.cohortStatus !== "CLOSED" &&
            addResourceBox()}
          {recordingTotal2 !== "" &&
          recordingTotal2 !== undefined &&
          recordingTotal2 !== null &&
          recordingTotal2?.length > 0 ? (
            <div>
              <div
                className="downloadsResourcesBox mt-2"
                // style={{ display: "flex", gap: "20px" }}
              >
                {recordingTotal2.map((item, index) => {
                  return (
                    <div className="d-flex" style={{ gap: "20%" }}>
                      <a
                        className="downloadsResourcesBox newuserTooltip"
                        href={item?.url}
                        target="_blank"
                      >
                        <div className="d-flex flex-column">
                          <div
                            style={{
                              // backgroundColor: "#000000",
                              width: "fit-content",
                              borderRadius: "10px",
                            }}
                          >
                            <img
                              className="documentBackgroundImg"
                              src={DocumentImage}
                            />
                          </div>
                          {/* <div className="d-flex documentPdfImg">
                          <img src={BlackPDF} />
                        </div> */}
                          <div className="d-flex flex-column">
                            <div className="documentFooterPdfText">
                              {item?.name}
                            </div>
                            <div className="documentFooterPdfText">
                              Resource {index + 1}
                            </div>
                          </div>
                        </div>
                        <span
                          className="tooltiptext   tooltip-bottom"
                          style={{ left: "75px", top: "50px", width: "150px" }}
                        >
                          View Resource
                        </span>
                      </a>

                      {index + 1 == recordingTotal2?.length &&
                        (cohortAdminBoolean || loginrole == "Admin") &&
                        parentData?.cohort.cohortStatus !== "CLOSED" &&
                        addResourceBox()}
                    </div>
                  );
                })}
              </div>
              <div className="pagination-box">
                <Pagination
                  activePage={resourcesPaginate?.currentPage}
                  itemsCountPerPage={5}
                  totalItemsCount={resourcesPaginate.totalElements}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange3.bind(this)}
                />
              </div>
            </div>
          ) : (
            <>
              <div className="emptyListCohort">No resources found</div>
            </>
          )}
          {/* <div className="downloadsResourcesBox">
            <div className="d-flex">
              <div
                style={{
                  backgroundColor: "#000000",
                  width: "fit-content",
                  borderRadius: "10px",
                }}
              >
                <img className="documentBackgroundImg" src={DocumentImage} />
              </div>
              <div className="d-flex documentPdfImg">
                <img src={BlackPDF} />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
    listGroupSessionPaginate:
      state.AdminMentorReducer.publicGroupSessionData.paginate,
    listGroupSessionData: state.AdminMentorReducer.publicGroupSessionData.data,
    detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
    invitedSessionList: state.MentorReducer.listSessionMemberList.data,
    invitedSessionListPaginate:
      state.MentorReducer.listSessionMemberList.paginate,
    groupSessionCounter:
      state.MentorReducer.listCohortGroupSessionCounters.data,
    sessionFeedBackData: state.MentorReducer.cohortViewFeedBack.data,
    sessionNotesFeedBackData:
      state.MentorReducer.cohortSessionNotesViewFeedBack,
    cohortGroupSessionHoursData: state.MentorReducer.cohortGroupSessionHours,
    cohortGroupSessionHoursFilteredData:
      state.MentorReducer.cohortGroupSessionHoursFilter,
    cohortCounterData: state.AdminMentorReducer.adminDashCohortCounter,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getNamesList,
  getCohortApplicationCounter,
  getStepperTooltipData,
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortGroupSessionHours,
  getCohortPublicData,
  cohortGroupSessionHoursFilter,
})(withRouter(ScheduleResources));

// export default ScheduleResources
